import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, volumes } from '../data/content';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { VolumeCard } from '../components/VolumeCard';
import { InsideLookSection } from '../components/InsideLookSection';
import { BonusCard } from '../components/BonusCard';
import { BenefitsGrid } from '../components/BenefitsGrid';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { AudienceSection } from '../components/AudienceSection';
import { CtaButton } from '../components/CtaButton';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQAccordion } from '../components/FAQAccordion';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
type LandingPageProps = {
  guaranteeEnabled: boolean;
  testimonialsEnabled: boolean;
  salesPopupEnabled: boolean;
};
export function LandingPage({
  guaranteeEnabled,
  testimonialsEnabled,
  salesPopupEnabled
}: LandingPageProps) {
  return <div className="min-h-screen w-full bg-slate-200 font-sans text-slate-600" data-id="element-184" data-mp="38itsz65yvsor">
      <main className="mx-auto w-full max-w-[768px] overflow-hidden bg-white" data-id="element-185" data-mp="3dbdfismmty5p">
        <HeroSection guaranteeEnabled={guaranteeEnabled} data-id="element-186" data-mp="3i9y4tx0cixfd" />

        <ProblemSection data-id="element-187" data-mp="3ibj05ouhikea" />

        <section className="bg-white px-4 py-6 md:px-12 md:py-8" data-id="element-188" data-mp="3n89ea6mqb5x2">
          <p className="text-center text-[13px] font-bold uppercase leading-tight text-teal-700 md:text-[14px]" data-id="element-189" data-mp="3n6omgorsu12w">
            Una colección completa de rehabilitación miofascial 6 en 1
          </p>
          <h2 className="mt-1 text-center text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-blue-950 md:text-[30px]" data-id="element-190" data-mp="30jhba1zhh7">
            ¿Qué incluye ATLAS MIOFASCIAL™?
          </h2>
          <div className="mt-4 space-y-2.5" data-id="element-191" data-mp="21x9amreiaplv">
            {volumes.map(v => <VolumeCard key={v.number} {...v} data-id="element-192" data-mp="356m3fzba4z04" />)}
          </div>
          <div className="mt-5 text-center" data-id="element-193" data-mp="30814e37rkld9">
            <p className="text-[15px] font-extrabold uppercase leading-tight text-blue-950 md:text-[17px]" data-id="element-194" data-mp="309c6lylk9l29">
              6 volúmenes · 240 páginas
            </p>
            <div className="mt-2.5" data-id="element-195" data-mp="396walfat5vgk">
              <CtaButton mode="scroll" data-id="element-196" data-mp="39a0jur34rhe3">Quiero los 6 volúmenes + 5 bonos gratis</CtaButton>
            </div>
          </div>
        </section>

        <InsideLookSection data-id="element-197" data-mp="3j6n35bft60e0" />

        <section className="bg-blue-950 px-4 py-6 md:px-12 md:py-8" data-id="element-198" data-mp="3j5bzdbmd4smw">
          <h2 className="flex items-center justify-center gap-2 text-center text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-amber-400 md:text-[30px]" data-id="element-199" data-mp="s45j61en8hr">
            <GiftIcon className="h-6 w-6 shrink-0 md:h-8 md:w-8" strokeWidth={2.5} aria-hidden data-id="element-200" data-mp="apsaeosq5wdn" />
            ¡Además, recibís 5 bonos profesionales GRATIS!
          </h2>
          <p className="mx-auto mt-1.5 max-w-[560px] text-center text-[14px] leading-[1.4] text-blue-200 md:text-[15px]" data-id="element-201" data-mp="5oumdvl1a848">
            Cinco recursos complementarios para facilitar la planificación y aplicación de ejercicios terapéuticos.
          </p>
          <div className="mt-4 space-y-2.5" data-id="element-202" data-mp="fdjcszbhj7pf">
            {bonuses.map(b => <BonusCard key={b.number} {...b} data-id="element-203" data-mp="kd4mo4s710gx" />)}
          </div>
          <div className="mt-4 text-center" data-id="element-204" data-mp="6m9b2kqb859n">
            <p className="text-[14px] font-extrabold uppercase leading-tight text-amber-400 md:text-[16px]" data-id="element-205" data-mp="6lhep7ow23ib">
              Los 5 bonos están incluidos sin costo adicional.
            </p>
            <p className="mt-1 text-[13px] font-bold text-white md:text-[14px]" data-id="element-206" data-mp="3su8yrw5tgde0">200 páginas de recursos complementarios.</p>
          </div>
        </section>

        <BenefitsGrid data-id="element-207" data-mp="1ktnom0ntmo3" />
        <OfferSection guaranteeEnabled={guaranteeEnabled} data-id="element-208" data-mp="3js9emuzi8t6u" />
        {guaranteeEnabled && <GuaranteeSection data-id="element-209" data-mp="3nud26hzg7o8h" />}
        <AudienceSection data-id="element-210" data-mp="3numkdje94r3m" />
        {testimonialsEnabled && <TestimonialsSection data-id="element-211" data-mp="3nwh2yr21w74j" />}
        <FAQAccordion data-id="element-212" data-mp="3gqwqnwry6kq7" />
        <FinalCTA guaranteeEnabled={guaranteeEnabled} data-id="element-213" data-mp="3gq4y6utnd345" />
        <Footer data-id="element-214" data-mp="3bs3eq8sb71s5" />
      </main>
      {salesPopupEnabled && <PurchasePopup data-id="element-215" data-mp="3bteg61ya7xg3" />}
    </div>;
}